import * as React from 'react';
import { useForm } from "react-hook-form";
import type { SubmitHandler } from "react-hook-form";

import Button from '../Button/Button';
import SubmitButton from '../SubmitButton/SubmitButton';
import AssetRow from '../AssetRow/AssetRow';
import { Entity } from '../../types/Entity';

type Input = {
    name: string;
    amount: string;
};

type AssetManagementProps = {
    assets: Entity[];
    setAssets: (incomes: Entity[]) => void;
};

function AssetManagement({assets, setAssets}: AssetManagementProps) {

    const [add, setAdd] = React.useState<boolean>(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<Input>();

    const onSubmit: SubmitHandler<Input> = (data) => {
        createAsset(data);
        setAdd(false);
    };

    const createAsset = (data: Input) => {
        const asset: Entity = new Entity(
            data.name,
            parseFloat(data.amount)
        );

        assets.push(asset);
        setAssets([...assets]);
    };

    const removeAsset = (index: number) => {
        assets.splice(index, 1);
        setAssets([...assets]);
    };


    return (
        <div>
            <h3>Assets</h3>
            {assets.map((asset, index) => (
                <AssetRow key={asset.id} asset={asset} index={index} remove={removeAsset}></AssetRow>
            ))}
            <Button callback={() => { setAdd(true) }}>Add Asset</Button>
            { add && (
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="name">Name</label>
                        <input id="name" {...register("name", { required: true })} />
                        {errors.name && <span>This field is required</span>}

                        <label htmlFor="name">Amount</label>
                        <input id="amount" type="number" min={0} step={0.01} {...register("amount", { required: true })} />
                        {errors.amount && <span>This field is required</span>}

                        <Button callback={() => { setAdd(false) }}>Cancel</Button>
                        <SubmitButton>Add</SubmitButton>
                    </form>
                </div>
            )}
        </div>
    );
}


export default AssetManagement;
